import { SEO_PATH_EXPLORE } from 'src/modules/Opportunities/constants';

export const getSearchErrorStatusCode = (pathname: string) =>
  pathname === SEO_PATH_EXPLORE ? 410 : 404;
